import { buildAddressEditFormSchema } from '../address/update-form.js';
import { CustomerAddressType } from './rules.js';
export const customerAddressEditFormSchema = buildAddressEditFormSchema(CustomerAddressType, undefined, { requireFullAddress: true });
//# sourceMappingURL=update-form.js.map